package music.jammers.shared.event.track.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class BackgroundType {

    LIGHT,
    DARK,
}